// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__um5pp","active":"Tabs_active__iMp2N"};